import React, { useContext, useEffect } from "react";
import Col from "../../UIcomponent/Column";
import "./Profile.scss";
import { Route, Switch, Redirect } from "react-router-dom";
import ProfileMenu from "./ProfileMenu/ProfileMenu";
import ProfileCalendar from "./ProfileCalendar/ProfileCalendar";
import ProfileHome from "./ProfileHome/ProfileHome";
import ProfileSettings from "./ProfileSetting/ProfileSettings";
import ProfileWeekly from "./ProfileSchedule/ProfileWeekly";
import LocalContext from "../../Context/LocalContetxt";
import ProfileLessons from "./ProfileLessons/ProfileLessons";

const Profile = (props) => {
  let PROPS = props;
  const config = useContext(LocalContext).config;
  const hasToken = useContext(LocalContext).hasToken;
  const ID = useContext(LocalContext).config.userID;
  return !hasToken ? (
    <Redirect to="/login" />
  ) : (
    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
      <Col className="l__Profile" xl={22} lg={22} md={23} sm={24} xs={24}>
        <Col
          className="w__Profile__Side"
          xl={5}
          lg={5.5}
          md={8}
          sm={24}
          xs={24}
        >
          <Col
            xl={24}
            lg={24}
            md={24}
            sm={22}
            xs={22}
            className="l__Profile__Menu"
          >
            <ProfileMenu id={ID} {...props} />
          </Col>
        </Col>
        {/* {config && */}
        <Col
          className="w__Profile__Content"
          xl={18.5}
          lg={18}
          md={17}
          sm={22}
          xs={22}
        >
          <Switch>
            <Route
              path="/profile"
              exact
              component={(props) => <ProfileHome {...PROPS} />}
            />

            <Route
              path="/profile/lessons"
              exact
              component={(props) => <ProfileLessons {...PROPS} />}
            />
            <Route
              path="/profile/calendar"
              exact
              component={(props) => <ProfileCalendar {...PROPS} />}
            />
            <Route
              path="/profile/weekly"
              exact
              component={(props) => <ProfileWeekly {...PROPS} />}
            />
            <Route
              path="/profile/setting"
              exact
              component={(props) => (
                <ProfileSettings timezone={config.timeZone} {...PROPS} />
              )}
            />
          </Switch>
        </Col>
        {/* } */}
      </Col>
    </Col>
  );
};

export default Profile;
